import useTranslation from '@/hooks/useTranslation';

import LoadingScreenWithAnimation from '@/components/organisms/LoadingScreenWithAnimation/LoadingScreenWithAnimation';
import Link from '@/components/molecules/Link/Link';
import {
  formatPhoneNumber,
  getContactPhoneNumber,
  PHONE_NUMBER_FORMAT,
} from '@/utils/phone';

function OutageMessage() {
  const t = useTranslation(['common']);

  return (
    <LoadingScreenWithAnimation
      insteadOfAnimation={
        <img
          src="/assets/images/cd28c6bcc4fc0bf5a182a0156d84f34263e5c260.png"
          alt=""
          width={166}
          height={128}
        />
      }
      title={t('outage-screen.title')}
      content={
        <div className="w-full text-center text-base text-[#939393]">
          <div className="flex flex-col gap-2 text-base text-[#939393]">
            <div className="flex max-w-64 flex-col gap-5">
              <p>{t('outage-screen.content.line-1')}</p>
              <p>{t('outage-screen.content.line-2')}</p>
            </div>
            <div className="relative my-10 h-px">
              <div className="absolute -left-20 h-px w-[170%] border-b border-[#D3D3D3]"></div>
            </div>
            <p>{t('outage-screen.contact-team')}</p>
            <Link
              href={`mailto:${import.meta.env.VITE_CUSTOMER_SUPPORT_EMAIL}`}
              className="text-primary/70 underline"
            >
              {import.meta.env.VITE_CUSTOMER_SUPPORT_EMAIL}
            </Link>
            <Link
              href={`tel:${formatPhoneNumber(getContactPhoneNumber(), PHONE_NUMBER_FORMAT.SYSTEM)}`}
              className="text-primary/70"
            >
              {formatPhoneNumber(
                getContactPhoneNumber(),
                PHONE_NUMBER_FORMAT.CLEAN,
                true
              )}
            </Link>
          </div>
        </div>
      }
    />
  );
}

export default OutageMessage;
